import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import type { Document } from '@contentful/rich-text-types'
import { ShowMore } from '@ecomm/shared-components'
import classnames from 'classnames'

type TermsAndConditionsProps = {
  readonly termsAndConditions: {
    readonly json: Document
  }
  readonly termsAndConditionsTitle?: string
  readonly bodyClassNames?: string
  readonly showMoreBtnVisible?: boolean
}

export function TermsAndConditions({
  termsAndConditions,
  termsAndConditionsTitle = '',
  bodyClassNames = '',
  showMoreBtnVisible = false
}: TermsAndConditionsProps) {
  const body = (
    <div
      className={classnames(
        `max-w-8xl mx-auto text-sm leading-7 lg:mt-1 lg:px-7 ${bodyClassNames}`,
        !showMoreBtnVisible && '-mt-8'
      )}
      data-testid="TermsAndConditions"
    >
      {termsAndConditionsTitle}
      {documentToReactComponents(termsAndConditions.json)}
    </div>
  )

  return showMoreBtnVisible ? (
    <ShowMore
      btnClasses="mt-4 px-7"
      hiddenClasses="lg:max-h-36 md:max-h-[205px] max-h-80 overflow-hidden"
    >
      {body}
    </ShowMore>
  ) : (
    body
  )
}
